import React from 'react';
import { CTAButton } from './CTAButton';
import { Lock, Download, RotateCcw } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
export function FinalCTA() {
  const ref = useScrollReveal();
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-41">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col items-center text-center gap-6" data-id="element-42">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-43">
          Tu cuerpo lleva años esperando esto.
        </h2>
        <div className="w-full mt-2" data-id="element-44">
          <CTAButton text="Quiero mi Protocolo — $19.990" isCheckout={true} data-id="element-45" />
        </div>
        <div className="flex flex-col gap-3 mt-4 w-full bg-white p-5 rounded-xl border border-salvia-light shadow-sm" data-id="element-46">
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-47">
            <Lock className="w-4 h-4 text-salvia" data-id="element-48" />
            <span data-id="element-49">Pago seguro con Mercado Pago</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-50">
            <Download className="w-4 h-4 text-salvia" data-id="element-51" />
            <span data-id="element-52">Descarga inmediata al instante</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700 text-sm font-medium" data-id="element-53">
            <RotateCcw className="w-4 h-4 text-salvia" data-id="element-54" />
            <span data-id="element-55">Garantía de devolución 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}